// MALİYET & KÂR PANELİ — TEK KAYNAK (Teklif Oluşturucu + Sipariş Modalı ortak kullanır)
// Kâr Oranı kutusu segmente göre otomatik ayarlanır (bayi 35 / son kullanıcı 100), taban %35'tir.
import React from "react";
import { TrendingUp } from "lucide-react";
import { convertPrice } from "../appUtils";
import { SEGMENT_RATE_MIN } from "../utils/segmentPricing";

export default function MaliyetKarPanel({
  items, itemCosts, subtotal, targetCur, rates, fmt,
  karOrani, setKarOrani, isAdmin = true, testid = "quote-kar-orani", docLabel = "yalnızca size görünür",
}) {
  if (!isAdmin || !items || items.length === 0) return null;
  // itemCosts her zaman TL cinsinden → gösterim için targetCur'a çevir
  const totalCostTL = items.reduce((s, _, i) => s + (Number(itemCosts[i]) || 0), 0);
  const hasCosts = totalCostTL > 0;
  const totalCostDisplay = convertPrice(totalCostTL, "TL", targetCur, rates);
  const profit = hasCosts ? subtotal - totalCostDisplay : 0;
  return (
    <div className="zen-panel p-4 border border-rose-200 dark:border-rose-800/40 bg-rose-50/30 dark:bg-rose-900/10">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <h4 className="text-xs font-bold text-rose-600 dark:text-rose-400 flex items-center gap-1.5">
          <TrendingUp className="w-4 h-4" /> Maliyet &amp; Kâr <span className="text-[10px] font-normal text-slate-400">({docLabel} · Bayi: maliyet+%35 · Son kullanıcı: maliyet×2 · manuel ve müşteriye özel fiyatlar korunur)</span>
        </h4>
        <div className="flex items-center gap-2">
          <span className="text-[10px] text-slate-500">Kâr Oranı %<span className="opacity-60">(min {SEGMENT_RATE_MIN})</span></span>
          <input
            data-testid={testid}
            type="number" min={SEGMENT_RATE_MIN} max="999"
            value={karOrani}
            onChange={(e) => setKarOrani(Math.max(SEGMENT_RATE_MIN, Number(e.target.value) || SEGMENT_RATE_MIN))}
            className="zen-input !py-1 !text-xs !px-2 !w-16 text-center"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
        <div className="bg-[#ffffff] dark:bg-[#131B2E] rounded-lg p-2.5 border border-slate-200 dark:border-[#22304A]">
          <div className="text-[9px] uppercase tracking-wider text-slate-400 mb-0.5">Toplam Maliyet</div>
          <div className="text-sm font-bold text-rose-600">{hasCosts ? fmt(totalCostDisplay, targetCur) : "—"}</div>
        </div>
        <div className="bg-[#ffffff] dark:bg-[#131B2E] rounded-lg p-2.5 border border-slate-200 dark:border-[#22304A]">
          <div className="text-[9px] uppercase tracking-wider text-slate-400 mb-0.5">Satış Fiyatı</div>
          <div className="text-sm font-bold text-slate-700 dark:text-white">{fmt(subtotal, targetCur)}</div>
        </div>
        <div className="bg-[#ffffff] dark:bg-[#131B2E] rounded-lg p-2.5 border border-slate-200 dark:border-[#22304A]">
          <div className="text-[9px] uppercase tracking-wider text-slate-400 mb-0.5">Kâr</div>
          <div className={`text-sm font-bold ${profit > 0 ? "text-emerald-600" : "text-slate-400"}`}>{hasCosts ? fmt(profit, targetCur) : "—"}</div>
        </div>
        <div className="bg-[#ffffff] dark:bg-[#131B2E] rounded-lg p-2.5 border border-slate-200 dark:border-[#22304A]">
          <div className="text-[9px] uppercase tracking-wider text-slate-400 mb-0.5">Kâr Oranı</div>
          <div className={`text-sm font-bold ${Number(karOrani) >= SEGMENT_RATE_MIN ? "text-emerald-600" : "text-amber-500"}`}>
            {hasCosts ? `%${Number(karOrani).toFixed(0)}` : "—"}
          </div>
        </div>
      </div>
    </div>
  );
}
